import { ReactNode, useState } from 'react';
import { UISettingsContext } from './UISettingsContext';

export const UISettingsProvider = ({ children }: { children: ReactNode }) => {
  const [isIntegrationsBannerDismissed, setIsIntegrationsBannerDismissed] =
    useState<boolean>(false);

  return (
    <UISettingsContext.Provider
      value={{
        isIntegrationsBannerDismissed,
        setIsIntegrationsBannerDismissed,
      }}
    >
      {children}
    </UISettingsContext.Provider>
  );
};
